import dynamic from 'next/dynamic';
import { FC } from 'react';

const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false });

export interface VideoProps {
  uid: any;
  video_asset: any;
  video_url: any;
}

const Video: FC<VideoProps> = ({ uid, video_url, video_asset }) => {
  return (
    <div key={uid} className="aspect-video">
      {video_asset?.filename ? (
        <>
          <ReactPlayer
            width="100%"
            height="100%"
            controls
            url={video_asset?.filename}
          />
          <p className="!m-0 w-full !max-w-none pt-2 font-mono text-xs text-neutral-500 empty:hidden lg:text-right">
            {video_asset?.title && `${video_asset?.title}`}
            {video_asset?.copyright && ` © ${video_asset?.copyright}`}
            {video_asset?.source && ` / ${video_asset?.source}`}
          </p>
        </>
      ) : (
        <ReactPlayer width="100%" height="100%" controls url={video_url} />
      )}
    </div>
  );
};

export default Video;
